import React from 'react'
import PropTypes from 'prop-types'
import {convertStrongTags} from '#tools/convertTaggedText'

function StyledText({text, modifier}) {
  if (!text) {
    return null
  }
  return React.createElement('div', {className: `text text--${modifier}`}, ...convertStrongTags(text))
}

StyledText.propTypes = {
  text: PropTypes.string,
  modifier: PropTypes.string,
}

export default StyledText
